import styled from 'styled-components'

import { InstantTradeWallets } from '../instant-trade-wallets'

import { InstantTradeBottomPopover } from './instant-trade-bottom-popover'

import type { Pair } from '@root/entities/pair'
import type { ChildrenProps } from '@root/shared/react'

type InstantTradeBottomWalletsProps = {
  pair: Pair.PairMinimal
  type: 'wallets' | 'settings'
} & ChildrenProps

export const InstantTradeBottomWallets: React.FC<
  InstantTradeBottomWalletsProps
> = ({ pair, children, type }) => {
  return (
    <Popover type={type} content={<InstantTradeWallets pair={pair} />}>
      {children}
    </Popover>
  )
}

const Popover = styled(InstantTradeBottomPopover)`
  --instant-trade-wallet-border-color: var(--backgroundA-4);
  --instant-trade-wallets-padding: 10px;
  width: 325px;
`
